import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Nav, NavItem, NavLink,
  TabContent, TabPane,
  Card, CardBody, Input, Button, Label, Table
} from 'reactstrap';
import classnames from 'classnames';
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import API from "../utils/axiosInstance.js";
import "./AdminUploadTabs.css";
const AdminContentUploadTabs = () => {
  const navigate = useNavigate();
  const { courseId = 1 } = useParams();
  const [activeTab, setActiveTab] = useState('4');
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [students, setStudents] = useState([]);
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [selectedCourseId, setSelectedCourseId] = useState(courseId);
  const [courses, setCourses] = useState([]);

  const [course, setCourse] = useState({
    title: "", level: "Intermediate", duration: "", classes: "",
    description: "", requiredPlan: "free", status: "in_progress", video: null
  });

  const [video, setVideo] = useState({
    title: "", description: "", requiredPlan: "free", file: null
  });

  const [ebook, setEbook] = useState({
    title: "", description: "", file: null
  });

  const [schedules, setSchedules] = useState([]);
  const [scheduleForm, setScheduleForm] = useState({ title: "", date: "", time: "" });
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user && user.isAdmin) {
      setIsAuthorized(true);
      fetchCourses();
      fetchSchedulesByCourse(selectedCourseId);
      fetchStudents(selectedCourseId);
    } else {
      alert("Access Denied: Only Admin can access this page.");
      navigate("/dashboard");
    }
  }, [navigate, selectedCourseId]);

  const fetchCourses = async () => {
    try {
      const res = await API.get("courses/allCourses");
      setCourses(res.data);
    } catch (err) {
      console.error("Failed to load courses", err);
    }
  };

  const fetchStudents = async (courseId) => {
    try {
      const res = await API.get(`/courses/${courseId}/students`);
      setStudents(res.data);
    } catch (err) {
      console.error("Failed to load students", err);
    }
  };

  const fetchSchedulesByCourse = async (id) => {
    try {
      const res = await API.get(`/schedules/course/${id}`);
      setSchedules(res.data);
    } catch (err) {
      console.error("Failed to load schedules", err);
    }
  };

  const handleCourseUpload = async (e) => {
    e.preventDefault();
    if (!course.video) return alert("Select course video/image");
    const formData = new FormData();
    Object.entries(course).forEach(([key, value]) => formData.append(key, value));
    try {
      setUploading(true);
      await API.post("/courses/upload", formData);
      alert("✅ Course uploaded");
    } catch (err) {
      alert("❌ Upload failed");
    } finally {
      setUploading(false);
    }
  };

  const handleVideoUpload = async (e) => {
    e.preventDefault();
    if (!video.file) return alert("Select video file");
    const formData = new FormData();
    Object.entries(video).forEach(([key, value]) => formData.append(key, value));
    try {
      setUploading(true);
      await API.post("/videos/upload", formData);
      alert("✅ Video uploaded");
    } catch (err) {
      alert("❌ Upload failed");
    } finally {
      setUploading(false);
    }
  };

  const handleEbookUpload = async (e) => {
    e.preventDefault();
    if (!ebook.file) return alert("Select ebook file");
    const formData = new FormData();
    Object.entries(ebook).forEach(([key, value]) => formData.append(key, value));
    try {
      setUploading(true);
      await API.post("/ebooks/upload", formData);
      alert("✅ Ebook uploaded");
    } catch (err) {
      alert("❌ Upload failed");
    } finally {
      setUploading(false);
    }
  };

  const handleScheduleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    try {
      if (editingId) {
        await API.put(`/schedules/${editingId}`, scheduleForm, {
          headers: { Authorization: `Bearer ${token}` },
        });
      } else {
        await API.post("/schedules", {
          ...scheduleForm, courseId: selectedCourseId, userIds: selectedUserIds
        }, {
          headers: { Authorization: `Bearer ${token}` },
        });
      }
      setScheduleForm({ title: "", date: "", time: "" });
      setEditingId(null);
      fetchSchedulesByCourse(selectedCourseId);
    } catch (err) {
      alert("❌ Failed to save schedule");
    }
  };

  const handleScheduleDelete = async (id) => {
    if (window.confirm("Delete this session?")) {
      const token = localStorage.getItem("token");
      await API.delete(`/schedules/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchSchedulesByCourse(selectedCourseId);
    }
  };

  if (!isAuthorized) return null;

  return (
    <div className="dashboard-wrapper">
      <div className="sidebar-fixed">
        <Sidebar isOpen={true} />
      </div>
      <div className="dashboard-main">
        <Navbar onToggleSidebar={() => { }} />
        <div className="dashboard-place">
          <Nav tabs className="mb-4">
            {/* <NavItem><NavLink className={classnames({ active: activeTab === '1' })} onClick={() => setActiveTab('1')}>Course</NavLink></NavItem>
            <NavItem><NavLink className={classnames({ active: activeTab === '2' })} onClick={() => setActiveTab('2')}>Video</NavLink></NavItem>
            <NavItem><NavLink className={classnames({ active: activeTab === '3' })} onClick={() => setActiveTab('3')}>Ebook</NavLink></NavItem> */}
            <NavItem><NavLink className={classnames({ active: activeTab === '4' })} onClick={() => setActiveTab('4')}>Schedule</NavLink></NavItem>
          </Nav>

          <TabContent activeTab={activeTab}>
            {/* <TabPane tabId="1">
              <Card><CardBody>
                <form onSubmit={handleCourseUpload}>
                  <Label>Title</Label><Input value={course.title} onChange={(e) => setCourse({ ...course, title: e.target.value })} required />
                  <Label>Level</Label><Input value={course.level} onChange={(e) => setCourse({ ...course, level: e.target.value })} required />
                  <Label>Duration</Label><Input value={course.duration} onChange={(e) => setCourse({ ...course, duration: e.target.value })} required />
                  <Label>Classes</Label><Input value={course.classes} onChange={(e) => setCourse({ ...course, classes: e.target.value })} required />
                  <Label>Description</Label><Input type="textarea" value={course.description} onChange={(e) => setCourse({ ...course, description: e.target.value })} required />
                  <Label>Required Plan</Label>
                  <Input type="select" value={course.requiredPlan} onChange={(e) => setCourse({ ...course, requiredPlan: e.target.value })}>
                    <option value="free">Free</option>
                    <option value="Beginner">Beginner</option>
                    <option value="Intermediate">Intermediate</option>
                    <option value="Advanced">Advanced</option>
                  </Input>
                  <Label>Upload Video/Image</Label>
                  <Input type="file" accept="video/mp4,image/*" onChange={(e) => setCourse({ ...course, video: e.target.files[0] })} required />
                  <Button type="submit" style={{ marginTop: '20px' }}>Upload Course</Button>
                </form>
              </CardBody></Card>
            </TabPane>

            <TabPane tabId="2">
              <Card><CardBody>
                <form onSubmit={handleVideoUpload}>
                  <Label>Title</Label><Input value={video.title} onChange={(e) => setVideo({ ...video, title: e.target.value })} required />
                  <Label>Description</Label><Input type="textarea" value={video.description} onChange={(e) => setVideo({ ...video, description: e.target.value })} required />
                  <Label>Required Plan</Label>
                  <Input type="select" value={video.requiredPlan} onChange={(e) => setVideo({ ...video, requiredPlan: e.target.value })}>
                    <option value="free">Free</option>
                    <option value="premium">Premium</option>
                    <option value="pro">Pro</option>
                  </Input>
                  <Label>Upload Video</Label>
                  <Input type="file" accept="video/mp4" onChange={(e) => setVideo({ ...video, file: e.target.files[0] })} required />
                  <Button type="submit" style={{ marginTop: '20px' }}>Upload Video</Button>
                </form>
              </CardBody></Card>
            </TabPane>

            <TabPane tabId="3">
              <Card><CardBody>
                <form onSubmit={handleEbookUpload}>
                  <Label>Title</Label><Input value={ebook.title} onChange={(e) => setEbook({ ...ebook, title: e.target.value })} required />
                  <Label>Description</Label><Input type="textarea" value={ebook.description} onChange={(e) => setEbook({ ...ebook, description: e.target.value })} required />
                  <Label>Upload PDF</Label>
                  <Input type="file" accept="application/pdf" onChange={(e) => setEbook({ ...ebook, file: e.target.files[0] })} required />
                  <Button type="submit" style={{ marginTop: '20px' }}>Upload Ebook</Button>
                </form>
              </CardBody></Card>
            </TabPane> */}

            <TabPane tabId="4">
              <Card><CardBody>
                <Label>Select Course</Label>
                <Input type="select" value={selectedCourseId} onChange={(e) => {
                  setSelectedCourseId(e.target.value);
                  setEditingId(null);
                  setScheduleForm({ title: "", date: "", time: "" });
                  fetchSchedulesByCourse(e.target.value);
                  fetchStudents(e.target.value);
                }}>
                  <option value="">Select Course</option>
                  {courses.map((c) => c ? <option key={c.id} value={c.id}>{c.title}</option> : null)}
                </Input>

                <form onSubmit={handleScheduleSubmit} className="mt-3">
                  <Label>Class Title</Label><Input value={scheduleForm.title} onChange={(e) => setScheduleForm({ ...scheduleForm, title: e.target.value })} required />
                  <Label>Date</Label><Input type="date" value={scheduleForm.date} onChange={(e) => setScheduleForm({ ...scheduleForm, date: e.target.value })} required />
                  <Label>Time</Label><Input type="time" value={scheduleForm.time} onChange={(e) => setScheduleForm({ ...scheduleForm, time: e.target.value })} required />
                  <Label>Select Students</Label>
                  <Input type="select" multiple value={selectedUserIds} onChange={(e) => setSelectedUserIds([...e.target.selectedOptions].map(opt => parseInt(opt.value))) }>
                    {students.map((s) => s ? <option key={s.id} value={s.id}>{s.name || s.email}</option> : null)}
                  </Input>
                  <Button type="submit" className="mt-2">{editingId ? "Update Session" : "Add Session"}</Button>
                </form>

                <Table bordered className="mt-4">
                  <thead><tr><th>Title</th><th>Date</th><th>Time</th><th>Actions</th></tr></thead>
                  <tbody>
                    {schedules.map((s) => (
                      <tr key={s.id}>
                        <td>{s.title}</td><td>{s.date}</td><td>{s.time}</td>
                        <td>
                          <Button size="sm" onClick={() => setScheduleForm({ title: s.title, date: s.date, time: s.time }) || setEditingId(s.id)}>Edit</Button>{' '}
                          <Button size="sm" color="danger" onClick={() => handleScheduleDelete(s.id)}>Delete</Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </CardBody></Card>
            </TabPane>
          </TabContent>
        </div>
      </div>
    </div>
  );
};

export default AdminContentUploadTabs;
